import './App.css';
import { BrowserRouter } from "react-router-dom";
import Routes from './routes/routes'

const App = () => {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes />
    </BrowserRouter>
  );
};

export default App;
